import { useMediaQuery } from "@mui/material";

export function useBreakpoints() {
  const isSm = useMediaQuery("(min-width:640px)");
  const isSmOnly = useMediaQuery("(min-width:640px) and (max-width: 767px)");
  const isMd = useMediaQuery("(min-width:768px)");
  const isMdOnly = useMediaQuery("(min-width:768px) and (max-width: 1023px)");
  const isLg = useMediaQuery("(min-width:1024px)");
  const isLgOnly = useMediaQuery("(min-width:1024px) and (max-width: 1279px)");
  const isXl = useMediaQuery("(min-width:1280px)");
  const isXlOnly = useMediaQuery("(min-width:1280px) and (max-width: 1535px)");
  const is2Xl = useMediaQuery("(min-width:1536px)");
  const is2XlOnly = useMediaQuery("(min-width:1536px)");

  return {
    isSm,
    isSmOnly,
    isMd,
    isMdOnly,
    isLg,
    isLgOnly,
    isXl,
    isXlOnly,
    is2Xl,
    is2XlOnly,
  };
}
